import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { setInstallationPLPiechart } from "../../../../../store/slices/salesFinanceSlice";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import CommaConvert from "../../../../../utils/CommaConvert";
const SalesIntallation = ({ total, filteredQuotation, projectCostMap, onGeneratedHtml }) => {

    const dispatch = useDispatch();
    const currency = useCurrencySymbol();
    const USAComma = CommaConvert();

    const { tasks } = useSelector((state) => state.descriptionTasks);
    const associateInstallation = useSelector(
        (state) => state.salesFinance.associateInstallation
    );
    const { taxes } = useSelector((state) => state.salesTaxes);

    useEffect(() => {
        dispatch(fetchSalesTaxes());
    }, [dispatch]);
    const [installationEffortCost, setInstallationEffort] = useState(0);
    const [, setGroupedTasks] = useState({});
    const [quotedValue, setQuotedValue] = useState(0);
    const [GandATax, setGandATax] = useState(0);
    const [taxValue, setTaxValue] = useState(0);

    useEffect(() => {
        dispatch(fetchDescriptionTasks());
    }, [dispatch]);

    useEffect(() => {
        taxes?.forEach((data) => {
            if (data.taxName === "G&A Expenses") {
                setGandATax(data.taxPercentage);
            } else if (data.taxName === "Tax") {
                setTaxValue(data.taxPercentage);
            }
        });
    }, [taxes]);

    useEffect(() => {
        if (!projectCostMap) return;
        // Find the first key in projectServiceCostMap that has an Installation cost
        const serviceKey = Object.keys(projectCostMap).find(
            (key) =>
                projectCostMap[key]?.Installation &&
                projectCostMap[key].Installation !== "N/A"
        );
        if (serviceKey) {
            const costString = projectCostMap[serviceKey].Installation;
            const costValue = parseFloat(costString.replace(/[^\d.-]/g, "")); // Removes "$" and ","
            setInstallationEffort(costValue);
        } else {
            setInstallationEffort(0); // Reset if no valid cost is found
        }
    }, [projectCostMap]);

    useEffect(() => {
        // Loop through all dynamic projects
        if (filteredQuotation) {
            Object.values(filteredQuotation).forEach((services) => {
                if (services?.Installation && Array.isArray(services.Installation)) {
                    const firstInstall = services.Installation[0];
                    if (firstInstall?.QuotedValue) {
                        setQuotedValue(firstInstall.QuotedValue);
                    }
                }
            });
        }
    }, [filteredQuotation]);

    useEffect(() => {
        if (!tasks || tasks.length === 0 || !filteredQuotation) return;

        const validProjectNames = new Set(Object.keys(filteredQuotation));

        // 🔁 Step 2: Group tasks where projectname matches one of those keys
        const grouped = tasks.reduce((acc, task) => {
            if (validProjectNames.has(task.projectname)) {
                if (!acc[task.projectname]) {
                    acc[task.projectname] = [];
                }
                acc[task.projectname].push(task);
            }
            return acc;
        }, {});

        setGroupedTasks(grouped);
    }, [tasks, filteredQuotation]);

    const Total = installationEffortCost + associateInstallation;
    const GAExpensesTotal = quotedValue * GandATax;
    const GrossProfit = quotedValue - Total;
    const EBIT = GrossProfit - GAExpensesTotal;
    const TaxValueCalculated = EBIT * taxValue;
    const NetRevenue = EBIT - TaxValueCalculated;

    const InstallPLChart = {
        "G & A Expenses": GAExpensesTotal,
        "Net Revenue": NetRevenue,
        Tax: TaxValueCalculated,
    };

    dispatch(setInstallationPLPiechart(InstallPLChart));
    useEffect(() => {
        if (!quotedValue) return;

        const htmlString = `
      <div>

        <table border="1" style="border-collapse: collapse; width: 100%; font-size: 12px; text-align: center; background-color: #e7ebfb;">
          <thead>
            <tr>
              <th style="border: 1px solid black;">Installation Labour Cost</th>
              <th style="border: 1px solid black;">Associate Installation Cost</th>
              <th style="border: 1px solid black;">Total</th>
              <th style="border: 1px solid black;">Price</th>
              <th style="border: 1px solid black;">Gross Profit</th>
              <th style="border: 1px solid black;">G &amp; A Expenses</th>
              <th style="border: 1px solid black;">EBIT</th>
              <th style="border: 1px solid black;">Tax</th>
              <th style="border: 1px solid black;">Net Revenue</th>
              <th style="border: 1px solid black;">Net Revenue(%)</th>
              <th style="border: 1px solid black;">Note</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="border: 1px solid black;">${currency}${USAComma(total)}</td>
              <td style="border: 1px solid black;">${currency}${USAComma(associateInstallation)}</td>
              <td style="border: 1px solid black;">${currency}${USAComma(installationEffortCost + associateInstallation)}</td>
              <td style="border: 1px solid black;">${currency}${USAComma(quotedValue)}</td>
              <td style="border: 1px solid black;">${currency}${USAComma(quotedValue - (installationEffortCost + associateInstallation))}</td>
              <td style="border: 1px solid black;">${currency}${USAComma((quotedValue * GandATax) / 100)}</td>
              <td style="border: 1px solid black;">${currency}${USAComma((quotedValue - (installationEffortCost + associateInstallation)) - ((quotedValue * GandATax) / 100))}</td>
              <td style="border: 1px solid black;">${currency}${USAComma(EBIT * taxValue)}</td>
              <td style="border: 1px solid black;">${currency}${USAComma(NetRevenue)}</td>
              <td style="border: 1px solid black;">${USAComma((NetRevenue / quotedValue) * 100)}%</td>
              <td style="border: 1px solid black;"></td>
            </tr>
          </tbody>
        </table>
      </div>
    `;
        // Send HTML string to parent
        if (onGeneratedHtml) onGeneratedHtml(htmlString);
    }, [
        installationEffortCost,
        associateInstallation,
        quotedValue,
        GandATax,
        taxValue,
        NetRevenue,
        EBIT,
        onGeneratedHtml,
        total,
        currency,
        USAComma
    ]);



    return (
        <div className="bg-white mt-4 pb-3 rounded-md ">
            <div className="mt-4">
                <div className="bg-white text-lg font-semibold p-2">
                    <h2>Salesperson Finance - Installation P & L</h2>
                </div>
            </div>
            <div>
                <div className="flex w-full bg-[#e7ebfb] text-center border border-white text-black text-sm">
                    <div className="w-[15.4%] border border-white p-1">
                        Installation Labour Cost
                    </div>
                    <div className="w-[15.4%] border border-white p-1">
                        Associate Installation Cost
                    </div>
                    <div className="w-[7.7%] border border-white p-1">Total</div>
                    <div className="w-[7.7%] border border-white p-1">Price</div>
                    <div className="w-[7.7%] border border-white p-1">Gross Profit</div>
                    <div className="w-[7.7%] border border-white p-1">G & A Expenses</div>
                    <div className="w-[7.7%] border border-white p-1">EBIT</div>
                    <div className="w-[7.7%] border border-white p-1">Tax</div>
                    <div className="w-[7.7%] border border-white p-1">Net Revenue</div>
                    <div className="w-[7.7%] border border-white p-1">
                        {"Net Revenue(%)"}
                    </div>
                    <div className="w-[7.7%] border border-white p-1">Note</div>
                </div>

                <div className="flex w-full bg-[#e7ebfb] text-center text-sm">
                    <div className="w-[15.4%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {currency}{USAComma(installationEffortCost)}
                    </div>

                    <div className="w-[15.4%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {currency}{USAComma(associateInstallation)}
                    </div>
                    <div className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {/* {`${USAComma(installationEffortCost)} + ${USAComma(
                  associateInstallation
                )} = ${currency}${USAComma(installationEffortCost + associateInstallation)}`} */}

                        {`${currency}${USAComma(installationEffortCost + associateInstallation)}`}
                    </div>
                    <div className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {currency}{USAComma(quotedValue)}
                    </div>
                    <div className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {/* {`${quotedValue} - ${Total} = $${currency}{USAComma(quotedValue - Total)}`} */}
                        {` ${currency}${USAComma(quotedValue - Total)}`}
                    </div>
                    <div className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {/* {`${quotedValue} * ${GandATax}% = ${currency}${USAComma(
                  (quotedValue * GandATax)/100
                )}`} */}
                        {` ${currency}${USAComma((quotedValue * GandATax) / 100)}`}
                    </div>
                    <div className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center">
                        {/* {`${GrossProfit} - ${GAExpensesTotal} = ${USAComma(
                  GrossProfit - GAExpensesTotal
                )}`} */}
                        {`${currency}${USAComma(GrossProfit - GAExpensesTotal)}`}
                    </div>
                    <div
                        className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center"
                    >
                        {/* {`${EBIT} * ${taxValue}% = ${USAComma(EBIT * taxValue)}`} */}
                        {`${currency}${USAComma(EBIT * taxValue)}`}
                    </div>
                    <div
                        className="w-[7.7%] border border-white p-1 text-[13px] overflow-hidden text-ellipsis line-clamp-2 break-all break-words leading-snug text-xs text-center"
                    >
                        {/* {`${EBIT} - ${TaxValueCalculated} = ${currency}${USAComma(
                  EBIT - TaxValueCalculated
                )}`} */}

                        {` ${currency}${USAComma(EBIT - TaxValueCalculated)}`}
                    </div>
                    <div className="w-[7.7%] border border-white p-1 text-wrap flex-wrap text-[13px]">
                        {/* {`${NetRevenue} / ${quotedValue} = ${USAComma(
                  NetRevenue / quotedValue
                )}`} */}
                        {` ${USAComma(NetRevenue / quotedValue)}`}%
                    </div>
                    <div className="w-[7.7%] border border-white p-1"></div>
                </div>
            </div>
        </div>
    )
}

export default SalesIntallation